<template>
    <div>
        <div class="uk-child-width-1-3@s uk-grid-match uk-margin-top" uk-grid>
            <div>
                <div class="uk-card uk-card-small uk-card-default uk-card-hover uk-card-body">
                    <div class="numberCircle">1</div>
                    <p>{{$t('ins_1')}}<br>{{$t('ins_1_1')}}</p>
                </div>
            </div>
            <div>
                <div class="uk-card uk-card-small uk-card-default uk-card-hover uk-card-body">
                    <div class="numberCircle">2</div>
                    <p>{{$t('ins_2')}}</p>
                </div>
            </div>
            <div>
                <div class="uk-card uk-card-small uk-card-default uk-card-hover uk-card-body">
                    <div class="numberCircle">3</div>
                    <p>{{$t('ins_3')}}</p>
                </div>
            </div>
        </div>
        <div class="uk-margin-top">
            <p class="uk-text-warning">{{$t('warn')}}</p>
            <ul>
                <li>{{$t('warn_1')}}</li>
                <li>{{$t('warn_2')}}</li>
                <li>{{$t('warn_3')}}</li>
                <li>{{$t('warn_4')}}</li>
            </ul>
        </div>
        <div class="uk-flex uk-flex-center uk-margin-auto-top">
            <div class="uk-width-4-5@m uk-width-1-2@l uk-article uk-card uk-card-body uk-card-default mbk_border_top_primary_5px mbk_large_box_shadow">
                <h5 class="uk-text-danger">{{responseStatusText}}</h5>
                <h5 class="uk-text-danger">{{text}}</h5>
                <form @submit.prevent="checkClientExistence" class="uk-form-stacked" id="mbk_form">
                    <fieldset class="uk-fieldset">
                        <label class="uk-form-label">{{$t('birthday')}}</label>
                        <div class="uk-form-controls">
                            <date-picker style="width: 100%" :lang="vdp_lang" format="DD.MM.YYYY" required input-class="uk-input" v-model="birthday"></date-picker>
                        </div>
                        <small class="uk-text-danger">{{birthdayError}}</small>
                    </fieldset>
                    <fieldset class="uk-fieldset">
                        <label class="uk-form-label" for="account">{{$t('account')}}</label>
                        <div class="uk-form-controls">
                            <input v-model="account" id="account" inputmode="numeric" class="uk-input" type="number"
                                   :placeholder="$t('digit_range')" min="1" max="999999">
                        </div>
                        <small class="uk-text-danger">{{accountError}}</small>
                    </fieldset>
                    <fieldset class="uk-fieldset">
                        <button type="submit" class="uk-button uk-button-primary">{{$t('next')}}</button>
                    </fieldset>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';
    import az from 'vue2-datepicker/locale/az';
    import ru from 'vue2-datepicker/locale/ru';
    import {mapActions, mapGetters} from 'vuex';

    export default {
        name: "Card",
        components: {
            DatePicker
        },
        data() {
            return {
                birthday: new Date(),
                birthdayError: "",
                account: null,
                accountError: "",
                id: null,
                text: "",
                code: null,
                responseStatusText: ""
            }
        },
        methods: {
            ...mapActions(["set_sms_confirm"]),
            checkClientExistence() {
                this.birthdayError = !this.birthday ? this.$t('field_required') : "";
                this.accountError = !this.account ? this.$t('field_required') : "";
                if (!this.birthday || !this.account) {
                    return
                }
                this.$http.post("/card/", {
                    account: Number(this.account),
                    dateofbirth: this.formattedDateOfBirth,
                }).then(response => {
                    this.text = "";
                    this.code = response.data.code;
                    confirm(response.data.text) ? this.confirm(response.data.id) : null
                }).catch(error => {
                    if (error.response.status === 400) {
                        this.id = error.response.data.id;
                        this.text = error.response.data.text;
                        this.code = error.response.data.code;
                    } else {
                        this.text = error.response.message;
                        this.responseStatusText = error.response.statusText;
                    }
                })
            },
            confirm(id){
                this.$http.post("/sms-confirm/", {
                    id: id
                }).then(response => {
                    this.set_sms_confirm({
                        code: response.data.code,
                        text: response.data.text,
                    });
                    this.$router.push({name: "smsStatus"})
                }).catch(error => {
                    this.responseStatusText = error.response.statusText;
                })
            }
        },
        computed: {
            ...mapGetters(["locale"]),
            formattedDateOfBirth() {
                return `${this.birthday.getMonth() + 1}-${this.birthday.getDate()}-${this.birthday.getFullYear()}`
            },
            vdp_lang() {
                switch (this.locale) {
                    case "ru":
                        return ru;
                    case "az":
                        return az;
                    default:
                        return ru;
                }
            }
        }
    }
</script>

<style scoped>
    .numberCircle {
        border-radius: 50%;
        width: 36px;
        height: 36px;
        line-height: 36px;
        padding: 2px;
        background: #fff;
        border: 2px solid #4a8b2f;
        color: #4a8b2f;
        text-align: center;
        font-size: 25px;
    }
</style>